import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { SectionHeading } from "@/accounts-payable/common";
import type { ApPurchaseDocument } from "@/accounts-payable/types";
import { formatApDateTime } from "@/accounts-payable/utils";

export const InvoiceActivitySection = ({
  invoice,
}: {
  invoice: Pick<ApPurchaseDocument, "system_messages">;
}) => (
  <Stack gap="md" fullWidth>
    <SectionHeading>Activity</SectionHeading>
    {invoice.system_messages.length > 0 ? (
      <Stack gap="md" fullWidth>
        {invoice.system_messages.map((m) => (
          <Stack key={m.id} gap="xs">
            <Typography textColor="secondary">{m.content}</Typography>
            <Typography variant="captionW1" textColor="tertiary">
              {formatApDateTime(m.created_at)}
            </Typography>
          </Stack>
        ))}
      </Stack>
    ) : (
      <Typography textColor="tertiary">No activity yet.</Typography>
    )}
  </Stack>
);
